const getRoutePath = (pathname: string): string => {
  const [pathWithoutHash = ''] = pathname.split('#');
  const [pathWithoutQuery = ''] = pathWithoutHash.split('?');

  return pathWithoutQuery;
};

export default getRoutePath;
